import React, { Component } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import history from '../../history';

class ProfileBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      billingClass: props.value === 2 ? 'active' : '',
      profileClass: props.value === 1 ? 'active' : '',
      supportClass: props.value === 3 ? 'active' : ''
    };
  }

  // unsafe
  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    let { profileClass, billingClass, supportClass } = this.state;
    if (props.value === 1) {
      profileClass = 'active';
      billingClass = '';
      supportClass = '';
    } else if (props.value === 2) {
      billingClass = 'active';
      profileClass = '';
      supportClass = '';
    } else if (props.value === 3) {
      supportClass = 'active';
      profileClass = '';
      billingClass = '';
    }
    this.setState({
      supportClass,
      billingClass,
      profileClass,
      ...props,
    });
  }

  // eslint-disable-next-line
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('reminder');
    history.push('/login');
  }

  onResize() {
    let { isMobileView } = this.state

    window.scrollTo(0,0)
    isMobileView = window.innerWidth < 768
    this.setState({ isMobileView })
  }

  // eslint-disable-next-line
  support() {
    const { subscriptionReminder, exist, dayDates } = this.state;
    sessionStorage.setItem('method', 'back');
    history.push('/support', { reminder: subscriptionReminder, exist, dayDates });
  }

  // eslint-disable-next-line
  billingDetail() {
    const { subscriptionReminder, exist, dayDates } = this.state;
    sessionStorage.setItem('method', 'back');
    history.push('/billingDetails', { reminder: subscriptionReminder, exist, dayDates });
  }

  // eslint-disable-next-line
  userProfile() {
    const { subscriptionReminder, exist, dayDates } = this.state;
    sessionStorage.setItem('method', 'back');
    history.push('/profileSettings', { reminder: subscriptionReminder, exist, dayDates });
  }

  render() {
    const { profileClass, supportClass, billingClass, isMobileView } = this.state;
    // const { profileClass, supportClass, isMobileView } = this.state;
    
    const profileText = isMobileView ? 'Profile' : 'Your Account'
    const billingText = isMobileView ? 'Billing' : 'Billing Details'
    const featureText = isMobileView ? 'Feature Request' : 'Support/Request Feature'
    
    return (
      <div className="col-lg-4 sidebar">
        <ReactResizeDetector handleWidth handleHeight onResize={() => this.onResize()} />
        <div className="sidebar-cntnt">
          <div className="sidebar-cntnt-bg" />
          <ul className="profile-lft-menu">
            <li className={`${profileClass}`}>
              <span className="profl-brd mb-hide" />
              <a onClick={() => this.userProfile()}>{profileText}</a>
            </li>
            <li className={`${billingClass}`}>
              <span className="profl-brd mb-hide" />
              <a onClick={() => this.billingDetail()}>{billingText}</a>
            </li>
            <li className={`${supportClass}`}>
              <span className="profl-brd mb-hide" />
              <a onClick={() => this.support()}>{featureText}</a>
            </li>
            <li className="mb-hide" style={{'background':'#f7f7f8'}}>
            </li>
            <li className="logout">
              <a onClick={() => this.logout()}>
                Logout
                <img src="/images/Logout.svg" alt="logout" className="mb-hide"/>
                {/* <svg width="24px" height="22px" viewBox="0 0 24 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
   
                  <title>23FBA4D2-2908-4604-B70D-1CFD99C28C20</title>
                  <desc>Created with sketchtool.</desc>
                  <defs>
                    <path d="M15.2593276,14.5212091 C14.8233378,14.5212091 14.4700629,14.874484 14.4700629,15.3104738 L14.4700629,20.1947592 C14.4700629,20.6301176 14.1161566,20.9840239 13.6807982,20.9840239 L2.63109273,20.9840239 C2.19573433,20.9840239 1.84182805,20.6301176 1.84182805,20.1947592 L1.84182805,3.67323973 C1.84182805,3.23788134 2.19573433,2.88397506 2.63109273,2.88397506 L13.6807982,2.88397506 C14.1161566,2.88397506 14.4700629,3.23788134 14.4700629,3.67323973 L14.4700629,8.55752523 C14.4700629,8.99351503 14.8233378,9.3467899 15.2593276,9.3467899 C15.6953174,9.3467899 16.0485923,8.99351503 16.0485923,8.55752523 L16.0485923,3.67323973 C16.0485923,2.36748026 14.9865577,1.30544572 13.6807982,1.30544572 L2.63109273,1.30544572 C1.32533324,1.30544572 0.26329869,2.36748026 0.26329869,3.67323973 L0.26329869,20.1947592 C0.26329869,21.5005187 1.32533324,22.5625533 2.63109273,22.5625533 L13.6807982,22.5625533 C14.9865577,22.5625533 16.0485923,21.5005187 16.0485923,20.1947592 L16.0485923,15.3104738 C16.0485923,14.874484 15.6953174,14.5212091 15.2593276,14.5212091 Z M23.7297161,11.9276852 C23.7294004,11.8784351 23.7243491,11.8288693 23.7148779,11.7796192 C23.7091952,11.7530999 23.699724,11.7284748 23.6921471,11.702587 C23.6848858,11.6795404 23.6798345,11.6558625 23.6703634,11.632816 C23.6574194,11.6009297 23.6397399,11.5722004 23.6230075,11.5425241 C23.6144834,11.5273702 23.6078536,11.5115849 23.5983824,11.4970624 C23.5687061,11.4522322 23.5349256,11.4111904 23.4970408,11.3733057 L18.9606631,6.83661249 C18.6522185,6.52816786 18.1527718,6.52816786 17.8446429,6.83661249 C17.5361982,7.14474141 17.5361982,7.64450379 17.8446429,7.95263272 L21.0354821,11.1447347 L6.84008321,11.1447347 C6.4040934,11.1447347 6.05081853,11.4980096 6.05081853,11.9339994 C6.05081853,12.3699892 6.4040934,12.723264 6.84008321,12.723264 L21.0361136,12.723264 L17.8443272,15.9150503 C17.5358825,16.2234949 17.5358825,16.7229416 17.8443272,17.0310705 C17.9983916,17.185135 18.2004434,17.2621672 18.4024952,17.2621672 C18.6045469,17.2621672 18.806283,17.185135 18.9606631,17.0310705 L23.4995665,12.4921673 C23.5039864,12.4877474 23.5068277,12.4823804 23.5112476,12.4779606 C23.5428182,12.4451272 23.5721788,12.4100838 23.5974353,12.3721991 C23.6116421,12.3507311 23.6217447,12.3273689 23.6337415,12.3049537 C23.646054,12.2822229 23.6599451,12.2601235 23.6700477,12.2361299 C23.6814131,12.2083478 23.6880429,12.1796185 23.6962513,12.151205 C23.7025654,12.1303684 23.710458,12.1101632 23.7148779,12.0883795 C23.7249805,12.0375509 23.7306632,11.9857751 23.7306632,11.9336837 C23.7303475,11.9317894 23.7297161,11.9298952 23.7297161,11.9276852 Z" id="path-1" />
                  </defs>
                  <g id="Aug-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="User-Profile---Edit-Ninja-Profile" transform="translate(-389.000000, -343.000000)">
                      <g id="Sidebar" transform="translate(137.000000, 110.000000)">
                        <g id="Icon-/-Action-/-Logout" transform="translate(252.000000, 232.000000)">
                          <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1" />
                          </mask>
                          <use id="Mask" fill="#FF003D" fill-rule="nonzero" xlinkHref="#path-1" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> */}
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
export default ProfileBar;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileBar.js